import { render, staticRenderFns } from "./PersonalInfo.vue?vue&type=template&id=7befc3aa"
import script from "./PersonalInfo.vue?vue&type=script&lang=ts"
export * from "./PersonalInfo.vue?vue&type=script&lang=ts"
import style0 from "./PersonalInfo.vue?vue&type=style&index=0&id=7befc3aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports